module.exports = __webpack_public_path__ + "static/media/  (23).a33b4c79.jpg";